import React from 'react'
import { Link } from 'react-router-dom'

const SavingsAccountForm = () => {
    return (
        <form>
            {/* x---------------------------------x Personal Information Form x---------------------------------x */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1">
                    <label htmlFor="firstName" className="block text-sm font-medium">First Name</label>
                    <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="firstName" placeholder="Enter your first name" required />
                </div>
                <div className="space-y-1">
                    <label htmlFor="lastName" className="block text-sm font-medium">Last Name</label>
                    <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="lastName" placeholder="Enter your last name" required />
                </div>
                <div className="space-y-1">
                    <label htmlFor="dob" className="block text-sm font-medium">Date of Birth</label>
                    <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="dob" placeholder='DD-MM-YY' required />
                </div>
                <div className="space-y-1">
                    <label htmlFor="ssn" className="block text-sm font-medium">Social Security Number (SSN)</label>
                    <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="ssn" placeholder="Enter your SSN" required />
                </div>
                <div className="space-y-1">
                    <label htmlFor="address" className="block text-sm font-medium">Address</label>
                    <input type="text" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="address" placeholder="Enter your address" required autoComplete='off' />
                </div>
                <div className="space-y-1">
                    <label htmlFor="email" className="block text-sm font-medium">Email address</label>
                    <input type="email" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="email" placeholder="Enter your email" required autoComplete='off' />
                </div>
                <div className="space-y-1">
                    <label htmlFor="phone" className="block text-sm font-medium">Phone Number</label>
                    <input type="tel" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="phone" placeholder="Enter your phone number" required autoComplete='off' />
                </div>
                <div className="space-y-1">
                    <label htmlFor="accountType" className="block text-sm font-medium">Account Type</label>
                    <select className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="accountType" required>
                        <option value="">Select Account Type</option>
                        <option value="standard">Standard Savings</option>
                        <option value="high-yield">High-Yield Savings</option>
                    </select>
                </div>
                <div className="space-y-1">
                    <label htmlFor="initialDeposit" className="block text-sm font-medium">Initial Deposit Amount ($)</label>
                    <input type="number" className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                        id="initialDeposit" placeholder="Enter deposit amount" min="0" required />
                </div>
            </div>

            {/* x---------------------------------x Terms and Conditions / Submit Buttons x---------------------------------x */}
            <div className='flex flex-col mt-3'>
                {/* x---------------------------------x Terms and Conditions x---------------------------------x */}
                <div className="mb-4 flex items-center gap-2">
                    <input type="checkbox" id="terms" required
                        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary" />
                    <label className="text-sm" htmlFor="terms">I agree to the <Link to="/savings-accounts" className="text-[var(--accent-color)]` hover:underline">terms and conditions</Link>.</label>
                </div>

                {/* x---------------------------------x Submit Button x---------------------------------x */}
                <div>
                    <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-4 w-full md:w-auto">
                        Submit Application
                    </button>
                </div>
            </div>
        </form>

    )
}

export default SavingsAccountForm